var React = require('react');

function Search (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M14.083 15L8.604 9.52a4.593 4.593 0 0 1-1.457.845 5.154 5.154 0 0 1-1.772.302c-1.502 0-2.774-.521-3.814-1.563C.52 8.063 0 6.806 0 5.334c0-1.473.52-2.73 1.563-3.771C2.603.52 3.865 0 5.342 0c1.48 0 2.737.52 3.772 1.563 1.034 1.041 1.552 2.3 1.552 3.773A5.189 5.189 0 0 1 9.5 8.625l5.5 5.458-.917.917zM5.354 9.417c1.129 0 2.088-.4 2.878-1.198.79-.799 1.185-1.76 1.185-2.886 0-1.125-.395-2.086-1.185-2.885-.79-.799-1.75-1.198-2.878-1.198-1.14 0-2.109.4-2.907 1.198-.798.799-1.197 1.76-1.197 2.885 0 1.125.399 2.087 1.197 2.886.798.798 1.767 1.198 2.907 1.198z"}));
}

Search.displayName = "Search";

Search.defaultProps = {"viewBox":"0 0 15 15"};

module.exports = Search;

Search.default = Search;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/search.svg
// module id = 1284
// module chunks = 0